var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.access_token)?_c('app-topbar'):_vm._e(),(_vm.access_token)?_c('app-nav'):_vm._e(),(!_vm.access_token)?_c('app-login'):_vm._e(),(_vm.access_token)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }